/* eslint-disable prettier/prettier */

export const REGEX = {
  NAME_ALPHA_SPACE: /^[A-Za-z ]*$/,
  ADDRESS_ALLOWED: /^[A-Za-z0-9 ,.\-/]*$/,
  PINCODE_UPTO_6_DIGITS: /^\d{0,6}$/,
  PHONE_UPTO_10_DIGITS: /^\d{0,10}$/,
  DIGITS_ONLY: /^[0-9]*$/,
  NON_DIGITS_GLOBAL: /\D/g,
  EMAIL_ALLOWED_CHARS: /^[A-Za-z0-9@._+-]*$/,
  EMAIL_SIMPLE: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
};
